export enum FollowAction {
  Follow = "Follow",
  UnFollow = "UnFollow",
}

export enum FollowButtonDisplay {
  BlueIcon = "blue-icon",
  BluePlusIcon = "blue-plus-icon",
  BlueSquareIcon = "blue-square-icon",
  CircleGrayIcon = "circle-gray-icon",
  Text = "text",
}

export enum FollowButtonOutline {
  Filled = "filled",
  Outlined = "outlined",
  Plain = "plain",
}

export enum FollowButtonSize {
  Compact = "compact",
  Full = "full",
  Large = "large",
  Normal = "normal",
  Small = "small",
  Thin = "thin",
}

export enum FollowButtonVariant {
  Dark = "dark",
  Homepage = "homepage",
  Light = "light",
  NewsletterColumnist = "newsletter-columnist",
  Style = "magazines-style",
}

export enum FollowType {
  Author = "Author",
  Section = "Section",
  Topic = "Topic",
}
